import { cn } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';
import { decodeHTMLEntities } from '@skin-seoul/utils';
import { CLASSNAME } from '@skin-seoul/service';

type ProductCardInfoNameProps = {
  brandClassName?: string;
  nameClassName?: string;
};

const ProductCardInfoName = ({ brandClassName, nameClassName }: ProductCardInfoNameProps) => {
  const { theme = 'light', brand, name, orientation } = useProductCard();

  return (
    <div className="flex flex-col gap-[4px] w-full min-w-0">
      <p
        className={cn(
          'text-label-medium font-semibold line-clamp-1',
          orientation === 'horizontal' ? 'pr-5' : '',
          theme === 'dark' ? 'text-neutral-100' : 'text-neutral-700',
          CLASSNAME.NOT_TRANSLATE,
          brandClassName,
        )}
      >
        {decodeHTMLEntities(brand)}
      </p>
      <p
        className={cn(
          'text-paragraph-small',
          orientation === 'horizontal' ? 'line-clamp-1 h-[20px]' : 'line-clamp-2 h-[40px]',
          theme === 'dark' ? 'text-neutral-100' : 'text-neutral-500',
          CLASSNAME.NOT_TRANSLATE,
          nameClassName,
        )}
      >
        {decodeHTMLEntities(name)}
      </p>
    </div>
  );
};

export default ProductCardInfoName;
